import React from 'react';

export type UseProductCardValidationState = {
  invalidProductFamilyIds: number[];
};

export type UseProductCardValidationDispatch = {
  addInvalidProductFamilyId: (productFamilyId: number) => void;
  clearInvalidProductFamilyId: (productFamilyId: number) => void;
  clearInvalidProductFamilyIds: () => void;
};

type UseProductCardValidation = [UseProductCardValidationState, UseProductCardValidationDispatch];

export const getDefaultState = (): UseProductCardValidationState => ({
  invalidProductFamilyIds: []
});

export const ProductCardValidationContext = React.createContext<any>(getDefaultState());

export const ProductCardValidationProvider = ({ children }: any) => {
  const [invalidProductFamilyIds, setInvalidProductFamilyIds] = React.useState<number[]>([]);

  const addInvalidProductFamilyId = (productFamilyId: number) => {
    if (invalidProductFamilyIds.includes(productFamilyId)) return;
    setInvalidProductFamilyIds([...invalidProductFamilyIds, productFamilyId]);
  };

  const clearInvalidProductFamilyId = (productFamilyId: number) => {
    if (invalidProductFamilyIds.includes(productFamilyId)) {
      setInvalidProductFamilyIds(invalidProductFamilyIds.filter(id => id !== productFamilyId));
    }
  };

  const clearInvalidProductFamilyIds = () => setInvalidProductFamilyIds([]);

  return (
    <ProductCardValidationContext.Provider
      value={[
        { invalidProductFamilyIds },
        { addInvalidProductFamilyId, clearInvalidProductFamilyId, clearInvalidProductFamilyIds }
      ]}
    >
      {children}
    </ProductCardValidationContext.Provider>
  );
};

export const useProductCardValidation = (): UseProductCardValidation => {
  const [state, dispatch] = React.useContext<UseProductCardValidation>(
    ProductCardValidationContext
  );
  return [state, dispatch];
};
